export default "__VITE_ASSET__V8EuZqCC__"